// Service layer for Milestones CRUD operations
import { supabase } from '../lib/supabase';

export const milestoneService = {
  // Get all milestones for a project
  async getByProjectId(projectId) {
    const { data, error } = await supabase?.from('milestones')?.select('*')?.eq('project_id', projectId)?.order('sequence_order', { ascending: true });

    if (error) throw error;

    return data?.map(milestone => ({
      id: milestone?.id,
      projectId: milestone?.project_id,
      name: milestone?.name,
      description: milestone?.description,
      status: milestone?.status,
      sequenceOrder: milestone?.sequence_order,
      targetDate: milestone?.target_date,
      completedDate: milestone?.completed_date,
      amount: milestone?.amount,
      documents: milestone?.documents,
      createdAt: milestone?.created_at,
      updatedAt: milestone?.updated_at
    }));
  },

  // Create milestone
  async create(milestoneData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase?.from('milestones')?.insert({
        project_id: milestoneData?.projectId,
        name: milestoneData?.name,
        description: milestoneData?.description,
        status: milestoneData?.status || 'pending',
        sequence_order: milestoneData?.sequenceOrder,
        target_date: milestoneData?.targetDate,
        amount: milestoneData?.amount,
        documents: milestoneData?.documents || []
      })?.select()?.single();

    if (error) throw error;
    return data;
  },

  // Update milestone
  async update(milestoneId, milestoneData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const updateData = {};
    if (milestoneData?.name !== undefined) updateData.name = milestoneData?.name;
    if (milestoneData?.description !== undefined) updateData.description = milestoneData?.description;
    if (milestoneData?.status !== undefined) updateData.status = milestoneData?.status;
    if (milestoneData?.targetDate !== undefined) updateData.target_date = milestoneData?.targetDate;
    if (milestoneData?.completedDate !== undefined) updateData.completed_date = milestoneData?.completedDate;
    if (milestoneData?.amount !== undefined) updateData.amount = milestoneData?.amount;
    if (milestoneData?.documents !== undefined) updateData.documents = milestoneData?.documents;

    const { data, error } = await supabase?.from('milestones')?.update(updateData)?.eq('id', milestoneId)?.select()?.single();

    if (error) throw error;
    return data;
  },

  // Delete milestone
  async delete(milestoneId) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { error } = await supabase?.from('milestones')?.delete()?.eq('id', milestoneId);

    if (error) throw error;
  },

  // Subscribe to real-time changes
  subscribeToChanges(projectId, callback) {
    const channel = supabase?.channel(`milestones_${projectId}`)?.on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'milestones',
          filter: `project_id=eq.${projectId}`
        },
        (payload) => {
          callback(payload);
        }
      )?.subscribe();

    return () => supabase?.removeChannel(channel);
  }
};
